(function () {
  const REVIEWS_SELECTORS = '.jdgm-rev-widg, .jdgm-review-widget, #judgeme_product_reviews';
  const SCROLL_OFFSET = 100;

  const scrollToReviews = () => {
    const target = document.querySelector(REVIEWS_SELECTORS);
    if (!target) return;

    const top =
      target.getBoundingClientRect().top + window.scrollY - SCROLL_OFFSET;

    window.scrollTo({ top, behavior: 'smooth' });
  };

  const handleBadgeClick = (event) => {
    const badge = event.target.closest('.jdgm-preview-badge');
    if (!badge) return;

    event.preventDefault();
    event.stopPropagation();
    scrollToReviews();
  };

  document.addEventListener('click', handleBadgeClick, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;

    const badge = event.target.closest('.jdgm-preview-badge');
    if (!badge) return;

    event.preventDefault();
    scrollToReviews();
  });
})();
